import React from "react";

export const zoneStatusColor = (s) => {
  if (s === "ON")        return { color: "#10b981", bg: "#d1fae5", border: "#10b981", label: "Irrigating" };
  if (s === "SCHEDULED") return { color: "#f59e0b", bg: "#fef3c7", border: "#f59e0b", label: "Scheduled" };
  if (s === "STANDBY")   return { color: "#3b82f6", bg: "#dbeafe", border: "#3b82f6", label: "Standby" };
  if (s === "FAULT")     return { color: "#ef4444", bg: "#fee2e2", border: "#ef4444", label: "Fault" };
  return { color: "#6b7280", bg: "#f3f4f6", border: "#6b7280", label: s };
};

export const signalQuality = (rssi) => {
  if (rssi == null)  return { label: "N/A",       color: "#9ca3af" };
  if (rssi > -70)    return { label: "Excellent",  color: "#10b981" };
  if (rssi > -80)    return { label: "Good",       color: "#22c55e" };
  if (rssi > -85)    return { label: "Fair",       color: "#f59e0b" };
  if (rssi > -90)    return { label: "Weak",       color: "#f97316" };
  return               { label: "Poor",       color: "#ef4444" };
};

export const battColor = (pct) => {
  if (pct > 60) return "#10b981";
  if (pct > 30) return "#f59e0b";
  return "#ef4444";
};

export const moistureColor = (pct) => {
  if (pct >= 40) return "#3b82f6";
  if (pct >= 28) return "#10b981";
  if (pct >= 18) return "#f59e0b";
  return "#ef4444";
};

export const severityColor = (s) => {
  if (s === "Critical") return { color: "#ef4444", bg: "#fee2e2" };
  if (s === "Warning")  return { color: "#f59e0b", bg: "#fef3c7" };
  return { color: "#3b82f6", bg: "#dbeafe" };
};

export const nodeStatusColor = (s) => {
  if (s === "Online")   return { color: "#10b981", bg: "#d1fae5" };
  if (s === "Weak")     return { color: "#f97316", bg: "#ffedd5" };
  if (s === "Low Batt") return { color: "#f59e0b", bg: "#fef3c7" };
  if (s === "Offline")  return { color: "#ef4444", bg: "#fee2e2" };
  return { color: "#6b7280", bg: "#f3f4f6" };
};

export const KpiCard = ({ label, value, unit, color, icon: Icon, sub, alert }) => (
  <div className="irr-kpi-card" style={{ borderTopColor: color }}>
    <div className="irr-kpi-top">
      {Icon && <div className="irr-kpi-icon" style={{ background: color + "18" }}><Icon size={18} color={color} /></div>}
      <div>
        <div className="irr-kpi-value" style={{ color }}>{value}<span className="irr-kpi-unit"> {unit}</span></div>
        <div className="irr-kpi-label">{label}</div>
      </div>
    </div>
    {sub   && <div className="irr-kpi-sub">{sub}</div>}
    {alert && <div className="irr-kpi-alert">{alert}</div>}
  </div>
);

export const StatusBadge = ({ status }) => {
  const st = zoneStatusColor(status);
  return <span className="irr-badge" style={{ background: st.bg, color: st.color }}>{st.label}</span>;
};

export const SeverityBadge = ({ severity }) => {
  const st = severityColor(severity);
  return <span className="irr-badge" style={{ background: st.bg, color: st.color }}>{severity}</span>;
};

export const NodeBadge = ({ status }) => {
  const st = nodeStatusColor(status);
  return <span className="irr-badge" style={{ background: st.bg, color: st.color }}>{status}</span>;
};

export const MiniBar = ({ value, max, color, height = 6 }) => (
  <div style={{ background: "#f3f4f6", borderRadius: 4, height, overflow: "hidden", width: "100%", minWidth: 60 }}>
    <div style={{ width: `${Math.min(100, (value / max) * 100)}%`, background: color, height: "100%", borderRadius: 4 }} />
  </div>
);

export const HealthRing = ({ score, size = 80 }) => {
  const r = (size - 14) / 2;
  const circ = 2 * Math.PI * r;
  const fill = (score / 100) * circ;
  const color = score >= 80 ? "#10b981" : score >= 60 ? "#f59e0b" : "#ef4444";
  return (
    <svg width={size} height={size}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#f3f4f6" strokeWidth={10} />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={10}
        strokeDasharray={`${fill} ${circ - fill}`} strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`} />
      <text x="50%" y="50%" textAnchor="middle" dy="0.35em" fontSize={size * 0.22} fontWeight="700" fill={color}>{score}</text>
    </svg>
  );
};
